import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
        <h1 className="font-heading font-bold text-xl text-slate-900 mb-2">Reimposta password</h1>
        {done ? (
          <p data-testid="forgot-success" className="text-sm text-slate-600">
            Se l'email è registrata, riceverai un link per reimpostare la password.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">Inserisci la tua email: ti invieremo un link di reset.</p>
            <input data-testid="forgot-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="email@esempio.it"
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button data-testid="forgot-submit-button" type="submit"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-md py-2 text-sm transition-colors">
              Invia link di reset
            </button>
          </form>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-indigo-600 hover:underline">Torna al login</Link>
        </div>
      </div>
    </div>
  );
}
